import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class SeasonAPI {
    
  allSeason: any = (data: any) => {
    return axios.post("/season/list", data, { headers: AuthHeader() });
  };

   seasonList: any = () => {
      return axios.get("/season/list", { headers: AuthHeader() });
  };

  activeSeasonList: any = () => {
    return axios.get("/season/activeList", { headers: AuthHeader() });
  };

  createNewSeason: any = (data: any) => {
    return axios.post("/season/add", data, { headers: AuthHeader() });
  };

  changeSeasonStatusById: any = (id: number) => {
    return axios.put(
      "/season/changeStatus",
      { id: id },
      { headers: AuthHeader() }
    );
  };

  deleteSeason: any = (id: number) => {
    return axios.delete("/season/delete", {
      data: { id: id },
      headers: AuthHeader(),
    });
  };

  getSeasonById: any = (id: number) => {
    return axios.get(`/season/details/${id}`, { headers: AuthHeader() });
  };

  updateSeason: any = (data: any) => {
    return axios.put("/season/update", data, {
      headers: AuthHeader(),
    });
  };
}
